import { restClient } from '@/Core'

/** Валюта запропонованої ціни за замовчуванням (ЗП-04, `SPEC-022` §4.1). */
export const REQUEST_DEFAULT_CURRENCY_CODE = 'EUR'

/** Валюта так, як її віддає картка валюти ядра. */
export interface CurrencyRef {
    '@id'?: string
    uuid?: string
    code?: string
    title?: string
}

let pending: Promise<CurrencyRef | null> | null = null

/**
 * Валюта за замовчуванням для форми створення запиту:
 * `GET /services/currencies/EUR` — ядро адресує валюту кодом, тож зашитого
 * IRI, як у легасі (`RequestResource.jsx:121-126`), тут немає. Той самий
 * дефолт ставить і бек, якщо валюту не передано; у формі вона потрібна, щоб
 * людина бачила, у чому вводить ціну.
 *
 * Один запит на сесію; невдалий не кешуємо — наступна форма спробує знову.
 */
export const LoadDefaultCurrencyTask = (): Promise<CurrencyRef | null> => {
    pending ??= (async () => {
        try {
            const currency = (await restClient.get(
                `/services/currencies/${REQUEST_DEFAULT_CURRENCY_CODE}`
            )) as unknown as CurrencyRef | null

            return currency && typeof currency === 'object' ? currency : null
        } catch {
            pending = null

            return null
        }
    })()

    return pending
}
